import { FOOD_MENU_KEY, FoodMenuState } from './foodmenu-reducer';

export enum FOOD_MENU_ACTION_TYPE {
  SET_FOOD_MENU_STATE = 'SET_FOOD_MENU_STATE',
  SET_FOOD_QC_KEYWORD = 'SET_FOOD_QC_KEYWORD',
  CALL_FOOD_MENU = 'CALL_FOOD_MENU',
  CALL_FOOD_QC_KEYWORD = 'CALL_FOOD_QC_KEYWORD',
}

export type SetFoodMenuStateAction<KeyName extends keyof FoodMenuState> = {
  type: FOOD_MENU_ACTION_TYPE.SET_FOOD_MENU_STATE;
  payload: { key: KeyName, value: FoodMenuState[KeyName] };
};


export type FoodMenuActions = SetFoodMenuStateAction<FOOD_MENU_KEY>;
